import React, { useState, useEffect, useRef, useMemo } from "react";
import { TableContainer, Paper, Typography, Box, Grid } from "@mui/material";
import { api, get, post } from "../../../../../utils/api";
import PaginationBox from "../../../../../Components/Masters/Pagination";
import DeleteAlertDialog from "../../../../../Components/Masters/DeleteAlertDialog";
import ColumnHeadings from "../../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../../Components/Masters/MenuActions";
import TableContent from "../../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../../utils/companyId";
import Add from "./Add";

import DateRangePickerComponent from "../../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../../Masters/Roles and Permissions/Filters/Range";
import Cards from "../../../../../Components/Common/Cards";
import NoDataFound from "../../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../../../Layout/Scope1Layout";
import { getMonthName } from "../../../../../utils/getMonthName";
import MonthYearFilter from "../../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../../Components/Common/BulkUploadModal";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../../Components/Masters/TopMenuUpload";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../../utils/common";
import Scope4Layout from "../../../../../Layout/Scope4Layout";
import View from "./View";
import BulkUpload from "../../../../Scope1/StationaryCombustion.js/NaturalGas/BulkUpload";
import FugitiveBulkUpload from "../../../../Scope1/FugitiveEmmissions/FugitiveBulkUpload";
// import BulkUpload from "../NaturalGas/BulkUpload";

const InHouseOffsetProject = () => {
  const [selectedDate, setSelectedDate] = useState({});
  const [cardData, setCardData] = useState(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Month of energy export": false,
    "Project Type": false,
    "Verification Status": false,
  });
  const columnWidth = "12% 12% 14% 15% 21% 17% 8%";
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    "Quantity Consumed": false,
    "Hours Used": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    projectType: [],
    verificationStatus: [],
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [hoursRange, setHoursRange] = useState({ min: "", max: "" });
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [bulkUploadTable, setBulkUploadTable] = useState(true);

  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    projectType: null,
    verificationStatus: null,
  });

  const [equipmentDetails, setEquipmentDetails] = useState({});
  const [formData, setFormData] = useState({});

  const allowedVerificationStatus= ["Verified", "Unverified", "Under Review", "Internal"];
  let bannerData = [
    {
      title: "Total Carbon Sequestered",
      description: truncateNumber(cardData?.total),
      // unit: cardData?.total?.unit,
    },
    {
      title: "Top Project Type By Carbon sequestered annually",
      description:
        cardData?.topProjectTypes
        ?.length > 0
          ? cardData?.topProjectTypes
          .map((el) => el.projectType)
          : "N/A",
    },
    {
      title: "Energy export Month",
      description: truncateNumber(cardData?.monthly?.totalCarbonSequestered),
      // unit: cardData?.monthly?.unit || "",
      filter: "date",
      defaultValue: {},
    },
  ];

  const onConfirm = async () => {
    try {
      const excelData = Object.values(formDataBulkUpload);
      const response = await post(`/scope4/in-house-offset-project/jsonupload`, { excelData });
      setBulkUploadTable(false);
      fetchData();
      setsnackOpen({
        open: true,
        message: "Bulk upload completed successfully!",
        severity: "success",
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchExcelData = async () => {
    await get("/scope4/in-house-offset-project/exportExcel")
      .then((res) => {
        let data = res?.data?.data;
        let arr =[];
       
          allowedVerificationStatus.forEach((status) => {
            arr.push({
              "S No.": arr.length + 1,
              "Project Name": "",
              "Project Type": "",
              "Month (in 01/25 or Jan-25)": "",
              "Project Location": "",
              "Verification Status": status,
              "Carbon sequestered annually (tCO₂e)": "",
              "Methodology Used": "",
            });
          });
        
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchCardData = async (month, year) => {
    try {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
      const response = await get(
        `/scope4/in-house-offset-project/cardData?year=${
          selectedYear ? selectedYear : currentYear
        }&month=${selectedMonth ? selectedMonth : currentMonth + 1}`
      );
      setCardData(response.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear,data]);

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedDate((prev) => ({
      ...prev,
      month,
      year,
    }));
    setSelectedMonth(month)
    setSelectedYear(year)
    fetchCardData(year, month, "");
  };

  const filters = [
    "Date",
    "Month of energy export",
    "Project Type",
    "Verification Status",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Month of energy export",
      required: true,
      type: "date",
    },
    {
      fieldName: "projectName",
      title: "Project name",
      type: "text",
    },
    {
      fieldName: "projectType",
      title: "Project Type",
      type: "select",
      options: [
        "Afforestation / Reforestation",
        "Agroforestry",
        "Biochar application",
        "Wetland / Peatland Restoration",
        "Mangrove Plantation",
        "Grassland Regeneration",
        "Soil Carbon Sequestration",
        "Ocean-based Carbon Sequestration",
        "Bamboo Plantation",
        "Others",
      ],
    },
    {
      fieldName: "projectLocation",
      title: "Project Location",
      type: "text",
    },
    {
      fieldName: "verificationStatus",
      title: "Verification status ",
      type: "select",
      options: ["Verified", "Unverified", "Under Review", "Internal"],
    },
    {
      fieldName: "carbonSequesteredAnnually",
      title: "Carbon sequestered annually (tCO₂e)",
      type: "number",
    },
    {
      fieldName: "methodologyUsed",
      title: "Methodology used ",
      type: "select",
      options:["Verra (VCS)", "Gold Standard","CDM (Clean Development Mechanism)","Plan Vivo","ACR / CAR",	"IPCC Guidelines","MoEFCC / India National Protocols", "Internal / Company-defined (upload required)","Others"]
    },
    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`scope4/in-house-offset-project/get?limit=null`);
      const data = response.data.data;
      const uniqueVerificationStatus = [
        ...new Set(
          data.map((el) => el.verificationStatus).filter(Boolean) // Filter out undefined values
        ),
      ];

      const uniqueProjectType = [
        ...new Set(
          data.map((el) => el.projectType).filter(Boolean) // Filter out undefined values
        ),
      ];


      const uniqueMethodology = [
        ...new Set(
          data.map((el) => el.methodologyUsed).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        verificationStatus: uniqueVerificationStatus,
        projectType: uniqueProjectType,
        methodologyUsed:uniqueMethodology
        // industrialEquipment: uniqueIndustrialEquipment,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };


  const computedInputData = useMemo(() => {
    return inputData.map((field) => {
      if (field.fieldName === "methodologyUsed") {
        const merged = Array.from(
          new Set([...(field.options || []), ...(uniqueValues.methodologyUsed || [])])
        );
        return { ...field, options: merged };
      }
      if (field.fieldName === "projectType") {
        const merged = Array.from(
          new Set([
            ...(field.options || []),
            ...(uniqueValues.projectType || []),
          ])
        );
        return { ...field, options: merged };
      }
      return field;
    });
  }, [uniqueValues, inputData]);

  // useEffect(()=>{
  //   fetchCardData();
  // })

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    // fetchCardData(selectedMonth, selectedMonth);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope4/in-house-offset-project/get?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: endMonth ? endMonth.format("YYYY-MM") : "",
    projectType: tempFilter?.projectType || "",
    verificationStatus: tempFilter?.verificationStatus || "",
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      projectType: tempFilter?.projectType || [],
      verificationStatus: tempFilter?.verificationStatus || [],
    });
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      projectType: [],
      verificationStatus: [],
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      projectType: [],
      verificationStatus: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isProjectTypeApplied = tempFilter?.projectType?.length > 0;
    const isVerificationStatusApplied =
      tempFilter?.verificationStatus?.length > 0;
   setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isProjectTypeApplied ||
        isVerificationStatusApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Month of energy export": isMonthApplied,
      "Project Type": isProjectTypeApplied,
      "Verification Status": isVerificationStatusApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      projectType: selectedFields.projectType,
      verificationStatus: selectedFields.verificationStatus,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = [
    { title: "Date", fieldName: "createdAt" },
    {
      fieldName: "consumptionPeriod",
      title: "Month of energy export",
    },
    {
      fieldName: "projectName",
      title: "Project name",
    },
    {
      fieldName: "projectType",
      title: "Project Type",
    },
    // {
    //   fieldName: "projectLocation",
    //   title: "Project Location",
    // },
    {
      fieldName: "carbonSequesteredAnnually",
      title: "Carbon sequestered annually (tCO₂e)",
    },
    {
      fieldName: "verificationStatus",
      title: "Verification status ",
    },
    // {
    //   fieldName:"methodologyUsed",
    //   title:"Methodology Used"
    // }
  ];

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Month of energy export":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
          />
        );
      // case "Industrial Process":
      //   return (
      //     <MultiSelect
      //       title="Industrial Process"
      //       selectedField={selectedFields.industrialProcess}
      //       selectedFields={selectedFields}
      //       setSelectedFields={setSelectedFields}
      //       setErrors={setErrors}
      //       field="industrialProcess"
      //       data={uniqueValues.industrialProcess}
      //     />
      //   );
      case "Project Type":
        return (
          <MultiSelect
            title="Project Type"
            // url={`${api}/master/getAllEquipmentTypes`}
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  projectType: newValue.projectType || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="projectType"
            data={uniqueValues.projectType}
          />
        );
      case "Verification Status":
        return (
          <MultiSelect
            title="Verification Status"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  verificationStatus: newValue.verificationStatus || newValue,
                };
              });
            }}
            errors={errors["Verification Status"]}
            setErrors={setErrors}
            field="verificationStatus"
            data={uniqueValues.verificationStatus}
          />
        );
      default:
        return null;
    }
  };
  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  return (
    <MainDashboardLayout sidebar={<Scope4Layout />}>
      <Unauthorized requiredModule="Environment | Scope 4 | Carbon Offsetting | InHouseoffSet">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <Add
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            title="Data"
            addUrl={`/scope4/in-house-offset-project/add`}
            updateUrl={`/scope4/in-house-offset-project/update`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={computedInputData}
          />
          <View
            id={element ? element._id : ""}
            data={element}
            title={"In-house Offset Projects"}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <Cards
            data={bannerData}
            title={"Carbon Offsetting"}
            onFilterChange={handlePeriodChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope4/in-house-offset-project/delte`,
                setsnackOpen,
                fetchData,
                method:"delete"
                // fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              // heading: "Coal",
              // setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%", marginBottom: "1rem" }}
          >
            <Box>
              <TableHeading heading={"In-house Offset Projects"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.fieldName}
                        {...{
                          fieldData:
                            el.fieldName === "consumptionPeriod"
                              ? getMonthName(item[el.fieldName]?.month) +
                                " " +
                                item[el.fieldName]?.year
                              : el?.fieldName === "projectLocation"
                              ? item?.projectLocation?.city +
                                ", " +
                                item?.projectLocation?.state +
                                ", " +
                                item?.projectLocation?.country
                              : el.fieldName === "quantityConsumed"
                              ? truncateNumber(item[el.fieldName].value) +
                                " " +
                                item[el.fieldName].unit
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].industryProcess
                              ? item[el.fieldName].industryProcess
                              : typeof item[el.fieldName] === "object" &&
                                item[el.fieldName] !== null &&
                                item[el.fieldName].name
                              ? item[el.fieldName].name
                              : item[el.fieldName],
                          dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>

        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            setFormDataBulkUpload={setFormDataBulkUpload}
            formDataBulkUpload={formDataBulkUpload}
            setMatchData={setMatchData}
            errorClose={uploadErrorClose}
            matchedKey="statusList"
            // setBulkUploadTable={setBulkUploadTable}
            // setJsonBulkUpload={setJsonBulkUpload}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"In-house Offset Projects"}
            url={"/scope4/in-house-offset-project/bulkupload"}
          />
        )}
        {bulkUploadTable &&
          <FugitiveBulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            setFormData={setFormDataBulkUpload}
            formData={formDataBulkUpload}
            {...{ formDataBulkUpload, setFormDataBulkUpload }}
            title1="Verification Status"
            keyValue1="verificationStatus"
            matched1="matchedVerificationStatus"
            options1={ ["Verified", "Unverified", "Under Review", "Internal"]}
            submitUrl={`scope4/in-house-offset-project/jsonUpload`}
            onConfirm={onConfirm}
          />
        }
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default InHouseOffsetProject;
